import { CMSApiBase, CMSImageBase, createCmsUrl } from './base';
import { fetcherCMS } from '@/modules/api';
import { getCMSLocale } from '@/modules/cms';

export interface LootboxApi extends CMSApiBase {
  title: string;
  text: string;
  character?: CMSImageBase;
  background?: CMSImageBase;
}

export const getLootboxModalUrl = (lang: string) =>
  createCmsUrl({
    path: 'lootbox',
    queryData: {
      ...getCMSLocale(lang),
      populate: {
        character: {
          fields: ['url'],
        },
        background: {
          fields: ['url'],
        },
      },
    },
  });

export const fetchLootboxModal = async (lang: string) => {
  const response = await fetcherCMS<LootboxApi>(getLootboxModalUrl(lang));
  return { data: response };
};
